module.exports = __webpack_public_path__ + "static/media/supervidal.31ed01bb.webp";